







import {defineComponent} from "@vue/composition-api";
import BlockMessage from "@base/Components/BlockMessage.vue";


export default defineComponent({
    components: {
        BlockMessage
    },
    props: {
        title: {
            required: false,
            default: 'Loading data...'
        }
    }
})
